import {
  FilterItem,
  FilterParams,
  TagFilterItem,
  TagsFilters,
} from '@mm/state/model/AudiencesModel';
import {
  MyLeadsAttributes,
  myLeadsAttributesBasedTypes,
  MyLeadsFilterTypes,
  MyleadsRelationalOperators,
  SubsectionKeys,
} from '@mm/state/interfaces/myLeads';
import { isObject, mapKeys, mapValues } from 'lodash';
import moment from 'moment';
import pluralize from 'pluralize';
import { convertToUpperSnakeCase } from '../../GetLeads/LeadsSearch/LeadsSearchFiltersMenu/helpers';
import ObjectUtils from '../../../../../../common/helpers/utils/object-utils';

export const convertObjectToMultidimensionalArray = (obj: {
  [key: string]: any;
}) => {
  const result: [string, any][] = [];

  Object.entries(obj).forEach(([key, val]) => {
    val.forEach((v: any) => {
      result.push([key, v]);
    });
  });

  return result;
};

export const getParamsByKeys = (variables, keysArr) => {
  const result = {};

  Object.keys(variables).forEach(key => {
    if (keysArr.includes(key)) {
      result[key] = variables[key];
    }
  });

  return result;
};

export const setPlaceholderByKey = (key: string) => {
  switch (key) {
    case SubsectionKeys.customerJourney[0]:
      return 'Time';
    case SubsectionKeys.customerJourney[1]:
      return 'Clicks';
    case SubsectionKeys.customerJourney[2]:
      return 'Views';
    case SubsectionKeys.customerJourney[3]:
      return 'Inches';
    case SubsectionKeys.customerJourney[4]:
      return 'Visits';
    default:
      return '';
  }
};

export const remappedNames = (
  value: string,
  csvFriendlyName: string = 'Imported',
) => {
  const formattedValue =
    typeof value === 'string' ? value?.split('::')?.[0] : value;
  switch (formattedValue) {
    case 'x-ray':
      return { friendlyName: 'X-Ray', value: 'x-ray' };
    case 'csv':
      return { friendlyName: csvFriendlyName, value: 'csv' };
    case 'web_chat':
      return { friendlyName: 'Webchat', value: 'web_chat' };
    case 'LeadsDB':
    case 'leads_db':
      return { friendlyName: 'Consumer Directory Leads', value: 'leads_db' };
    case 'voyager_b2b_directory':
      return { friendlyName: 'B2B Leads', value: 'voyager_b2b_directory' };
    case 'lgbtq+ donor/supporter':
      return { friendlyName: 'LGBTQ+ Donor/Supporter', value: formattedValue };
    case 'startDate':
    case 'start_date':
      return { friendlyName: 'Created from', value: 'start_date' };
    case 'endDate':
    case 'end_date':
      return { friendlyName: 'Created till', value: 'end_date' };
    case MyleadsRelationalOperators.GREATER_THAN:
      return {
        friendlyName: 'greater than',
        value: MyleadsRelationalOperators.GREATER_THAN,
      };
    case MyleadsRelationalOperators.LESS_THAN:
      return {
        friendlyName: 'less than',
        value: MyleadsRelationalOperators.LESS_THAN,
      };

    default:
      return { friendlyName: formattedValue, value: formattedValue };
  }
};

export const getMinutesAndSeconds = (seconds: number) => {
  const duration = moment.duration(Number(seconds), 'seconds');
  const minutes = Math.floor(duration.asMinutes());
  const minutesText = pluralize('minute', minutes);
  const remainingSeconds = Math.floor(duration.asSeconds()) % 60;
  const secondsText = pluralize('second', remainingSeconds);
  if (minutes && remainingSeconds) {
    return `${minutes} ${minutesText} ${remainingSeconds} ${secondsText}`;
  }
  if (minutes) {
    return `${minutes} ${minutesText}`;
  }
  if (remainingSeconds) {
    return `${remainingSeconds} ${secondsText}`;
  }
};

export const prepareEsFiltersStructure = (obj?: MyLeadsAttributes) =>
  mapValues(obj || {}, (value, key) => {
    if (isObject(value)) {
      const lowercased = myLeadsAttributesBasedTypes.includes(
        key as MyLeadsFilterTypes,
      );
      if (lowercased) {
        return ObjectUtils.deepSnakeKeys(value);
      }
      return mapKeys(value, (_, nestedKey) =>
        convertToUpperSnakeCase(nestedKey),
      );
    }
    return value;
  }) as MyLeadsAttributes;

export const unassignFilterParams = (
  params?: FilterParams | TagsFilters,
): TagFilterItem[] | FilterItem[] =>
  Object.values(params || {}).filter(v => typeof v === 'object');
